import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getRequestsPendingsForm } from '../api';
import { StudentsRemovalRequestsPendingFiltersResponse } from '../types';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentsRemovalRequestsPendingFiltersResponse,
  AxiosResultDefaultError
>();

export const useStudentsRemovalRequestsPendingFilters = useFetch;

export function StudentsRemovalRequestsPendingFiltersConsumer({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestsPendingFiltersResponse;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        if (loading) {
          return <Loading className="mx-auto" />;
        }

        if (!data) {
          return (
            <DisplayError
              textBody="Data no cargada"
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data });
      }}
    </FetchConsumer>
  );
}

export function StudentsRemovalRequestsPendingFiltersLoader({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestsPendingFiltersResponse;
  }) => ReactElement;
}) {
  const request = useCallback(async () => {
    return getRequestsPendingsForm();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <StudentsRemovalRequestsPendingFiltersConsumer>
        {({ data }) => children({ data })}
      </StudentsRemovalRequestsPendingFiltersConsumer>
    </FetchProvider>
  );
}
